import { Box, IconButton, Popper, type Theme } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ICON_COLOR_MAP: Record<'gray' | 'red', string> = {
  gray: '#8A9097',
  red: '#FF0000'
};

export const ViewerContainer = styled(Box)(() => ({
  width: '100%',
  height: '100%',
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
}));

export const OriginalViewerWrapper = styled(Box)(() => ({
  flex: 1,
  minWidth: 0,
}));

export const CrossRefIconButton = styled(IconButton, {
  shouldForwardProp: prop => prop !== 'iconColor',
})<{ iconColor: string }>(({ theme, iconColor }: { theme: Theme; iconColor: string }) => ({
  position: 'absolute',
  right: 0,
  top: '50%',
  transform: 'translateY(-50%)',
  padding: theme.spacing(0.25),
  color: iconColor,
}));

export const CrossRefPopper = styled(Popper)(({ theme }: { theme: Theme }) => ({
  zIndex: theme.zIndex.modal,
}));
